"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestStatus = void 0;
const react_1 = __importDefault(require("react"));
const ParsedTextFromOas_1 = require("./ParsedTextFromOas");
const tds_1 = require("@guided-methods/tds");
const TestStatus = ({ caption, passed }) => (react_1.default.createElement("div", null, passed !== undefined && (react_1.default.createElement("div", { className: "inline-flex justify-center gap-2 h-10" },
    react_1.default.createElement("div", null, caption?.length > 0 ?
        passed ? (react_1.default.createElement(tds_1.Icon, { icon: "IconTick", size: "20px", fillColor: "#1dab8b" })) : (react_1.default.createElement(tds_1.Icon, { icon: "IconCross", size: "20px", fillColor: "#ff2340" })) : react_1.default.createElement(react_1.default.Fragment, null)),
    react_1.default.createElement("div", null,
        react_1.default.createElement(ParsedTextFromOas_1.ParsedTextFromOas, { markup: caption }))))));
exports.TestStatus = TestStatus;
